export default __webpack_public_path__ + "static/media/fleet.b200ec0a.png";